/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useCallback, useRef } from "react";
import { api } from "../../services/api";
import Tabela from "../../components/Table";
import Load from "../../components/Load";
import Menu from "../../components/Menu";
import { MdSearch, MdMyLocation, MdClear } from "react-icons/md";
import useToast from "../../hooks/useToast";
import { MdSchedule, MdDirectionsBus } from "react-icons/md";
import {
  PageContent,
  PageHeader,
  PageTitle,
  PageSubtitle,
  SearchActions,
  SearchBar,
  SearchInput,
  BtnLocation,
  LocationBanner,
  TimeFilters,
  TimeFilterChip,
  CardList,
} from "./styled";
import ButtonsFilterTables from "../../components/ButtonsFilterTables";

const Linhas = () => {
  const [order, setOrder] = useState(1);
  const [columnOrder, setColumnOrder] = useState("name");
  const [linha, setLinha] = useState([]);
  const [searchLine, setSearchLine] = useState("");
  const [searchColumnName, setSearchColumnName] = useState("");
  const [searchColumnDescription, setSearchColumnDescription] = useState("");
  const [searchColumnCostCenter, setSearchColumnCostCenter] = useState("");
  const [searchColumnSchedules, setSearchColumnSchedules] = useState("");
  const [load, setload] = useState(false);
  const [selectedDate, setSelectedDate] = useState([]);
  const [filterlineslocation, setFilterlineslocation] = useState("");
  const [pressedbuttonlocation, setPressedbuttonlocation] = useState(false);
  const [userCoords, setUserCoords] = useState(null);
  const [lineDistances, setLineDistances] = useState({});
  const [timeFilter, setTimeFilter] = useState(null); // null | 30 | 60 | "running"
  const [activeShiftIds, setActiveShiftIds] = useState(new Set());

  const { showToast } = useToast();

  // Haversine: distância em km entre dois pontos
  const haversine = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  // Busca POIs de cada linha e calcula distância mínima
  const calcDistances = async (lines, coords) => {
    if (!lines || !coords) return;
    const distances = {};
    await Promise.allSettled(
      lines.map(async (line) => {
        const blsId = line.buslineshift[0]?.id;
        if (!blsId) return;
        try {
          const res = await api.get(`/busline/shift/locations?bus_line_shift_id=${blsId}`);
          const pois = res.data?.[0]?.poi;
          if (pois && pois.length > 0) {
            let minDist = Infinity;
            pois.forEach((p) => {
              const d = haversine(coords[0], coords[1], parseFloat(p.latitude), parseFloat(p.longitude));
              if (d < minDist) minDist = d;
            });
            distances[line.id] = minDist;
          }
        } catch (e) { /* ignora erros individuais */ }
      })
    );
    setLineDistances(distances);
  };

  let ccid = localStorage.getItem("CoastCenterID");

  const address = JSON.parse(localStorage.getItem("addressListFix"));

  localStorage.removeItem("LinhaID");

  const tabela = async () => {
    setload(true);
    if (ccid) {
      await api
        .get(`/busline?cost_center_id=${ccid}`)
        .then((resp) => {
          return setLinha(resp.data);
        })
        .catch((error) => {
          console.log("Ops! Ocorreu um erro. ", error);
          showToast("Erro ao carregar linhas.", "error");
        })
        .finally(function () {
          setload(false);
        });
    }
  };

  // Busca veículos ativos para saber quais shifts estão em execução
  const fetchActiveShifts = async () => {
    try {
      const res = await api.get(`/busline/allbus?cost_center_id=${ccid}`);
      if (res.data && Array.isArray(res.data)) {
        const ids = new Set(res.data.map(u => u.buss_line_shift_id).filter(Boolean));
        setActiveShiftIds(ids);
      }
    } catch (e) {
      console.log('Erro ao buscar veículos ativos:', e);
    }
  };

  useEffect(() => {
    tabela();
    fetchActiveShifts();
  }, []);

  const tabAddress = () => {
    try {
      //SE TIVER ENDERECO CADASTRADO, O SISTEMA CONSULTA A API E RETORNA OS ENDERECOS MAIS PROXIMOS (SE HOUVER)
      if (address) {
        setUserCoords([address[0].coords[1], address[0].coords[0]]);
        setload(true);
        api
          .get(
            `/busline?lat=${address[0].coords[1]}&lng=${address[0].coords[0]}&cost_center_id=${ccid}`
          )
          .then((resp) => {
            if (resp.status === 204) {
              showToast("Nao ha pontos proximo ao endereco cadastrado.", "error");
              setFilterlineslocation(
                "Filtrando linhas ate 2km da sua localizacao"
              );
              setPressedbuttonlocation(true);
              return setLinha(null);
            }
            const dataLocation = resp.data;
            if (dataLocation) {
              setFilterlineslocation("Filtrando linhas até 2km da sua localização");
              setPressedbuttonlocation(true);
              setLinha(dataLocation);
              calcDistances(dataLocation, [address[0].coords[1], address[0].coords[0]]);
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(function () {
            setload(false);
          });
      } else {
        //SE NAO, O SISTEMA CONSULTA A API COM AS COORDENADAS ATUAIS DO USUARIO E RETORNA OS ENDERECOS MAIS PROXIMOS (SE HOUVER)
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            setUserCoords([position.coords.latitude, position.coords.longitude]);
            setload(true);
            api
              .get(
                `/busline?lat=${position.coords.latitude}&lng=${position.coords.longitude}&cost_center_id=${ccid}`
              )
              .then((resp) => {
                if (resp.status === 204) {
                  showToast("Nao ha pontos proximo a posicao atual.", "error");
                  setFilterlineslocation("Filtrando linhas até 2km da sua localização");
                  setPressedbuttonlocation(true);
                  return setLinha(null);
                }
                const dataLocation = resp.data;
                if (dataLocation) {
                  setFilterlineslocation("Filtrando linhas até 2km da sua localização");
                  setPressedbuttonlocation(true);
                  setLinha(dataLocation);
                  calcDistances(dataLocation, [position.coords.latitude, position.coords.longitude]);
                }
              })
              .catch((error) => {
                console.log(error);
              })
              .finally(function () {
                setload(false);
              });
            return [position.coords.longitude, position.coords.latitude];
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resetFilterLocation = () => {
    setload(true);
    setPressedbuttonlocation(false);
    setFilterlineslocation("");
    setUserCoords(null);
    setLineDistances({});
    tabela();
    setload(false);
  };

  const childToParent = useCallback((childdata) => {
    setSelectedDate(childdata);
  }, []);

  let filterLineBusca;

  const checkContains = (days) => {
    return selectedDate
      .filter((item) => item !== "ida" && item !== "retorno")
      .every((e) => days.includes(e));
  };

  filterLineBusca =
    //existe a possibilidade de nao haver conteudo no ccid
    linha &&
    linha.filter((r) => {
      //no for eu salvo a posicao da linha e pego todos os buslineshift
      //quando o usuario busca eu pego o valor do horario daquela determinada linha
      for (let i = 0; i < r.buslineshift.length; i++) {
        if (
          searchColumnCostCenter === "" &&
          searchColumnName === "" &&
          searchColumnDescription === "" &&
          searchColumnSchedules === ""
        ) {
          if (
            (r.name.toUpperCase().includes(searchLine.toUpperCase()) ||
              r.description.toUpperCase().includes(searchLine.toUpperCase()) ||
              r.cost_center.name
                .toUpperCase()
                .includes(searchLine.toUpperCase()) ||
              r.buslineshift[i].hour.includes(searchLine)) &&
            checkContains(r.buslineshift[i].weekday) &&
            (selectedDate.includes(
              r.buslineshift[i].direction_name.toLowerCase()
            ) ||
              (!selectedDate.includes("ida") &&
                !selectedDate.includes("retorno")))
          ) {
            return true;
          }
        } else if (searchColumnName !== "") {
          if (
            r.name.toUpperCase().includes(searchColumnName.toUpperCase()) &&
            checkContains(r.buslineshift[i].weekday) &&
            (selectedDate.includes(
              r.buslineshift[i].direction_name.toLowerCase()
            ) ||
              (!selectedDate.includes("ida") &&
                !selectedDate.includes("retorno")))
          ) {
            return true;
          }
        } else if (searchColumnDescription !== "") {
          if (
            r.description
              .toUpperCase()
              .includes(searchColumnDescription.toUpperCase()) &&
            checkContains(r.buslineshift[i].weekday) &&
            (selectedDate.includes(
              r.buslineshift[i].direction_name.toLowerCase()
            ) ||
              (!selectedDate.includes("ida") &&
                !selectedDate.includes("retorno")))
          ) {
            return true;
          }
        } else if (searchColumnCostCenter !== "") {
          if (
            r.cost_center.name
              .toUpperCase()
              .includes(searchColumnCostCenter.toUpperCase()) &&
            checkContains(r.buslineshift[i].weekday) &&
            (selectedDate.includes(
              r.buslineshift[i].direction_name.toLowerCase()
            ) ||
              (!selectedDate.includes("ida") &&
                !selectedDate.includes("retorno")))
          ) {
            return true;
          }
        } else if (searchColumnSchedules !== "") {
          if (
            r.buslineshift[i].hour.includes(searchColumnSchedules) &&
            checkContains(r.buslineshift[i].weekday) &&
            (selectedDate.includes(
              r.buslineshift[i].direction_name.toLowerCase()
            ) ||
              (!selectedDate.includes("ida") &&
                !selectedDate.includes("retorno")))
          ) {
            return true;
          }
        }
      }
      return false;
    });

  filterLineBusca &&
    filterLineBusca.sort((a, b) => {
      if (columnOrder === "cost_center")
        return a[columnOrder]["name"] < b[columnOrder]["name"]
          ? -order
          : order;
      else if (columnOrder === "hour")
        return a["buslineshift"][0][columnOrder] <
          b["buslineshift"][0][columnOrder]
          ? -order
          : order;
      else return a[columnOrder] < b[columnOrder] ? -order : order;
    });

  const handleOrder = (fieldName) => {
    setOrder(-order);
    setColumnOrder(fieldName);
  };

  // Verifica se uma linha tem veículo ativo (dados reais da API /busline/allbus)
  const isLineRunning = (line) => {
    return line.buslineshift.some((shift) => activeShiftIds.has(shift.id));
  };

  // Filtra linhas por tempo ou execução
  const filterByTime = (lines) => {
    if (!timeFilter || !lines) return lines;

    if (timeFilter === "running") {
      return lines.filter((line) => isLineRunning(line));
    }

    const now = new Date();
    const nowMinutes = now.getHours() * 60 + now.getMinutes();

    return lines.filter((line) => {
      return line.buslineshift.some((shift) => {
        const [h, m] = shift.hour.split(':').map(Number);
        const shiftMinutes = h * 60 + m;
        const diff = shiftMinutes - nowMinutes;
        return diff >= 0 && diff <= timeFilter;
      });
    });
  };

  // Ordena: linhas em execução primeiro
  const sortWithRunning = (lines) => {
    if (!lines) return lines;
    return [...lines].sort((a, b) => {
      const aRunning = isLineRunning(a) ? 0 : 1;
      const bRunning = isLineRunning(b) ? 0 : 1;
      return aRunning - bRunning;
    });
  };

  const finalFilteredLines = sortWithRunning(filterByTime(filterLineBusca));

  return (
    <>
      {load ? <Load /> : null}
      <Menu title="Linhas" />
      <PageContent>
        <PageHeader>
          <PageTitle>Linhas de onibus</PageTitle>
          <PageSubtitle>Selecione uma linha para ver as viagens</PageSubtitle>
        </PageHeader>

        <SearchActions>
          <SearchBar>
            <MdSearch
              size={20}
              style={{
                position: "absolute",
                left: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#adb5bd",
              }}
            />
            <SearchInput
              name="pesquisa_search-line"
              type="text"
              placeholder="Buscar por linha"
              value={searchLine}
              onChange={(env) => setSearchLine(env.target.value)}
            />
          </SearchBar>
          <BtnLocation
            onClick={() => (pressedbuttonlocation ? resetFilterLocation() : tabAddress())}
            $active={pressedbuttonlocation}
          >
            <MdMyLocation size={20} />
          </BtnLocation>
        </SearchActions>

        {pressedbuttonlocation && (
          <LocationBanner onClick={() => resetFilterLocation()}>
            <span>{filterlineslocation}</span>
            <MdClear size={18} />
          </LocationBanner>
        )}

        <TimeFilters>
          <TimeFilterChip
            $active={timeFilter === "running"}
            onClick={() => setTimeFilter(timeFilter === "running" ? null : "running")}
          >
            <MdDirectionsBus size={14} />
            Em execução
          </TimeFilterChip>
          <TimeFilterChip
            $active={timeFilter === 30}
            onClick={() => setTimeFilter(timeFilter === 30 ? null : 30)}
          >
            <MdSchedule size={14} />
            Próximos 30min
          </TimeFilterChip>
          <TimeFilterChip
            $active={timeFilter === 60}
            onClick={() => setTimeFilter(timeFilter === 60 ? null : 60)}
          >
            <MdSchedule size={14} />
            Próxima 1h
          </TimeFilterChip>
        </TimeFilters>

        <ButtonsFilterTables childToParent={childToParent} />

        <CardList>
          {finalFilteredLines &&
            finalFilteredLines.map((data, index) => (
              <Tabela
                key={index}
                data={{ line: data, filter: selectedDate, distance: lineDistances[data.id], running: isLineRunning(data) }}
              />
            ))}
        </CardList>
      </PageContent>
    </>
  );
};

export default Linhas;
